<div class="header bg-primary text-on-primary-900">
  <div class="buttons">
    <button mat-icon-button class="toggle-sidebar-folded lt-lg:hidden text-on-primary-900 font-weight-900"
      (click)="toggleSidebarLock()" aria-label="Abrir menu lateral com últimas operações">
      <mat-icon class="text-on-primary-900 font-weight-900" color="primary">format_list_bulleted</mat-icon>
    </button>
    <button mat-icon-button class="toggle-sidebar-opened lg:hidden text-on-primary-900 font-weight-900"
      (click)="toggleSidebarOpen()" aria-label="Fechar menu lateral com últimas operações">
      <mat-icon class="text-on-primary-900 font-weight-900" color="primary">arrow_forward</mat-icon>
    </button>
  </div>
  <div class="logo">
    <span class="logo-text">Últimas Operações</span>
  </div>
</div>

<div class="header">
  <mat-checkbox
    color="primary"
    class="ml-2 mb-1"
    (click)="toggleSelectAll($event)"
    [checked]="!!selectedIds.length"
    [indeterminate]="isIndeterminate">
    Selecionar todos
  </mat-checkbox>

  @if (selectedIds?.length) {
    <div class="toolbar-separator"></div>
  }

  @if (selectedIds?.length > 1) {
    <button mat-icon-button [matMenuTriggerFor]="moreMenu"
      aria-label="Ferramentas" (click)="$event.stopPropagation()"
      >
      <mat-icon class="text-secondary">more_vert</mat-icon>
    </button>
  }

  <mat-menu #moreMenu="matMenu">
    <button mat-menu-item aria-label="refazer selecionadas"
      (click)="doRefazerBloco()">
      <ng-container>
        <mat-icon>redo</mat-icon>
        <span>Refazer Selecionadas</span>
      </ng-container>
    </button>

    <button mat-menu-item aria-label="desfazer selecionadas"
      (click)="doDesfazerBloco()">
      <ng-container>
        <mat-icon>undo</mat-icon>
        <span>Desfazer Selecionadas</span>
      </ng-container>
    </button>
  </mat-menu>

  <div class="operacoes-list-control flex flex-row justify-start items-center content-cente">
    <div class="my-auto">
      <cdk-columns-select [formCtrl]="filtros"
        [multiple]="false"
        [tooltip]="'Campos'"
        [elements]="opcoesFiltros"
        [idField]="'valor'"
        [labelField]="'label'"
        [alturaMenu]="176"
      [showReset]="false"></cdk-columns-select>
    </div>

    <div class="toolbar-separator"></div>

    @if (!loteAtual()) {
      <div>
        {{displayedOperacoes() ? displayedOperacoes().length : 0}}/{{operacoes()?.length}}
      </div>
    }

    @if (loteAtual()) {
      <div>
        {{displayedOperacoes() ? displayedOperacoes().length : 0}}/{{operacoesLoteAtual()?.length}}
      </div>
    }

  </div>
</div>

@if (operacoesPendentes() > 0) {
  <mat-progress-bar mode="determinate"
  [value]="(operacoesProcessando() * 100) / operacoesPendentes()"></mat-progress-bar>
}

<div class="content">
  @if (!loteAtual()) {
    <div class="operacoes">
      <cdk-virtual-scroll-viewport class="operacoes-viewport" [itemSize]="176" [minBufferPx]="704" [maxBufferPx]="1408">
        <mat-card *cdkVirtualFor="let operacao of displayedOperacoes(); trackBy: trackByOperacaoId" appearance="outlined" class="quick-panel-operation-card mt-2 ml-2 mr-2">
          <mat-card-title>
            <div class="card-header">
              <div class="check">
                <mat-checkbox color="primary" class="pr-1 pb-1" [checked]="selectedIds.indexOf(operacao.id) !== -1"
                  (change)="toggleInSelected(operacao.id)"
                  (click)="$event.stopPropagation();">
                </mat-checkbox>
              </div>
              <span class="text-secondary pre-wrap">{{operacao.type | titleCasePipe}}</span>
              <span>
                @for (quickPanelAction of getQuickPanelActions(operacao); track quickPanelAction) {
                  <button mat-icon-button
                    (click)="quickPanelAction.action()"
                    aria-label="{{quickPanelAction.label | lowercase}}"
                    matTooltip="{{quickPanelAction.label}}">
                    <mat-icon>{{quickPanelAction.icon}}</mat-icon>
                  </button>
                }
                @if (operacao.status === 0) {
                  <span class="operacoe-status"><mat-spinner color="primary" [diameter]="16"></mat-spinner></span>
                }
                @if (operacao.status === 1) {
                  <span class="operacoe-status"><mat-icon>check</mat-icon></span>
                }
                @if (operacao.status === 2) {
                  <span class="operacoe-status"><mat-icon class="warn">clear</mat-icon></span>
                }
                @if (operacao.status === 3) {
                  <span class="operacoe-status"><mat-icon>cancel</mat-icon></span>
                }
              </span>
            </div>
          </mat-card-title>
          <mat-card-content>
            <div class="card-content">
              <span class="text-secondary">{{operacao.content}}</span>
              <span
              class="mt-2 card-date text-secondary">{{operacao.dateTime | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <div class="card-actions">
              @if (operacao.status >= 2 && operacao.redo) {
                <div class="button">
                  <button mat-icon-button class="text-secondary" matTooltip="Refazer" (click)="refazer(operacao)">
                    <mat-icon>redo</mat-icon>
                  </button>
                </div>
              }
              @if (operacao.status === 1 && operacao.undo) {
                <div class="button">
                  <button mat-icon-button class="text-secondary" matTooltip="Desfazer" (click)="desfazer(operacao)">
                    <mat-icon>undo</mat-icon>
                  </button>
                </div>
              }
              @if (operacao.lote) {
                <div class="button">
                  <button mat-icon-button class="text-secondary" matTooltip="Ver Lote" (click)="verLote(operacao.lote)">
                    <mat-icon>all_inbox</mat-icon>
                  </button>
                </div>
              }
            </div>
          </mat-card-actions>
        </mat-card>
      </cdk-virtual-scroll-viewport>
    </div>
  }
  @if (loteAtual()) {
    <div class="operacoes">
      <mat-card appearance="outlined" class="mt-2 ml-2 mr-2">
        <mat-card-title>
          <div class="card-header">
            <span class="text-secondary">Exibindo Lote: {{loteAtual().id}}</span>
          </div>
        </mat-card-title>
        <mat-card-actions>
          <div class="card-actions">
            <div class="button">
              <button mat-icon-button class="text-secondary" matTooltip="Voltar" aria-description="Voltar" (click)="verOperacoes()">
                <mat-icon>arrow_left</mat-icon>
              </button>
            </div>
            @if (operacoesRefazerLoteAtual().length > 0) {
              <div class="button">
                <button mat-icon-button class="text-secondary" matTooltip="Refazer Lote" aria-description="Refazer Lote" (click)="refazerLoteAtual()">
                  <mat-icon>redo</mat-icon>
                </button>
              </div>
            }
            @if (operacoesDesfazerLoteAtual().length > 0) {
              <div class="button">
                <button mat-icon-button class="text-secondary" matTooltip="Desfazer Lote" aria-description="Desfazer Lote" (click)="desfazerLoteAtual()">
                  <mat-icon>undo</mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-card-actions>
      </mat-card>
      <cdk-virtual-scroll-viewport class="operacoes-viewport lote-viewport" [itemSize]="176" [minBufferPx]="704" [maxBufferPx]="1408">
        <mat-card *cdkVirtualFor="let operacao of displayedOperacoes(); trackBy: trackByOperacaoId" appearance="outlined" class="quick-panel-operation-card mt-2 ml-2 mr-2">
          <mat-card-title>
            <div class="card-header">
              <div class="check">
                <mat-checkbox color="primary" class="pr-1 pb-1" [checked]="selectedIds.indexOf(operacao.id) !== -1"
                  (change)="toggleInSelected(operacao.id)"
                  (click)="$event.stopPropagation();">
                </mat-checkbox>
              </div>
              <span class="text-secondary">{{operacao.type | titleCasePipe}}</span>
              <span>
                @for (quickPanelAction of getQuickPanelActions(operacao); track quickPanelAction) {
                  <button mat-icon-button
                    (click)="quickPanelAction.action()"
                    aria-label="{{quickPanelAction.label | lowercase}}"
                    matTooltip="{{quickPanelAction.label}}">
                    <mat-icon>{{quickPanelAction.icon}}</mat-icon>
                  </button>
                }
                @if (operacao.status === 0) {
                  <span><mat-spinner color="primary" [diameter]="16"></mat-spinner></span>
                }
                @if (operacao.status === 1) {
                  <span><mat-icon>check</mat-icon></span>
                }
                @if (operacao.status === 2) {
                  <span><mat-icon class="warn">clear</mat-icon></span>
                }
                @if (operacao.status === 3) {
                  <span><mat-icon>cancel</mat-icon></span>
                }
              </span>
            </div>
          </mat-card-title>
          <mat-card-content>
            <div class="card-content">
              <span class="text-secondary">
                {{operacao.content}}
              </span>
              <span class="mt-2 card-date text-secondary">
                {{operacao.dateTime | date: 'dd/MM/yyyy HH:mm:ss'}}
              </span>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <div class="card-actions">
              @if (operacao.status >= 2 && operacao.redo) {
                <div class="button">
                  <button mat-icon-button class="text-secondary" matTooltip="Refazer" aria-description="Refazer" (click)="refazer(operacao)">
                    <mat-icon>redo</mat-icon>
                  </button>
                </div>
              }
              @if (operacao.status === 1 && operacao.undo) {
                <div class="button">
                  <button mat-icon-button class="text-secondary" matTooltip="Desfazer" aria-description="Desfazer" (click)="desfazer(operacao)">
                    <mat-icon>undo</mat-icon>
                  </button>
                </div>
              }
            </div>
          </mat-card-actions>
        </mat-card>
      </cdk-virtual-scroll-viewport>
    </div>
  }
</div>
